import { render, staticRenderFns } from "./BuTab.vue?vue&type=template&id=6940e8e3&"
import script from "./BuTab.vue?vue&type=script&lang=js&"
export * from "./BuTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports